import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
const List = Menu;
import { HOMESTAY } from "@/lib/data";

const navItems = [
  { label: "Stay", href: "/#stay" },
  { label: "Amenities", href: "/#amenities" },
  { label: "Experiences", href: "/#experiences" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Guides", href: "/blog" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const location = useLocation();

  // The transparent (over-hero) header only ever appears on the home page.
  // Every other route shows the solid (cream + dark text) header.
  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        transparent
          ? "bg-transparent"
          : "bg-mrn-cream/80 backdrop-blur-xl border-b border-mrn-sand/60"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex flex-row items-end leading-none">
          <img
            src={transparent
              ? "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/pwk6rf2w_Gemini_Generated_Image_sjx6clsjx6clsjx6-removebg-preview.png"
              : "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/la6lt5vu_Gemini_Generated_Image_tuir8ctuir8ctuir-removebg-preview.png"
            }
            alt="Mrinmaya vacation home"
            data-testid="header-logo-mark"
            className="h-[3.63rem] md:h-[4.356rem] w-auto object-contain transition-opacity duration-300"
          />
          <span
            style={{ fontSize: "0.81rem" }}
            className={`font-accent tracking-wide mb-[1.1rem] md:mb-[1.4rem] ${transparent ? "text-mrn-sand" : "text-mrn-terracotta"}`}
          >
            vacation home
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <a
              key={n.label}
              href={n.href}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={`link-underline text-sm tracking-wide font-medium ${
                scrolled ? "text-mrn-wood" : "text-mrn-cream"
              }`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3" />

        <button
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          className={`md:hidden rounded-full p-2 ${transparent ? "text-mrn-cream" : "text-mrn-wood"}`}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <List size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-mrn-cream border-t border-mrn-sand" data-testid="mobile-menu">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navItems.map((n) => (
              <a
                key={n.label}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-mrn-wood text-lg font-medium"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
